/**
 * @file オプション有無
 */
'use strict';

/**
 * @classname RadioOptionView
 * @classdesc オプション有無
 */
export default class RadioOptionView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('RadioOptionView.constructor');
		this._$e = $e;
		this._$input = $e.find('input[type=radio]');
		this._$optionId = $('.option_id');
		this._$optionDescription = $('.option_description');
		this._$convertOptionDescription = $('#convert_option_description');
		$e.on('click', (e) => {this.onClick(e);});
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof FormSubmitView
	 * @return {undefined}
	 */
	onClick(e) {
		console.log('RadioOptionView.onClick');
		const value = this._$input.val();
		this._$optionId.attr('name', `option_id[${value}]`);
		this._$optionDescription.attr('name', `option_description[${value}]`);
		this._$convertOptionDescription.attr('name', `convert_option_description[${value}]`);
	};
}
